import ShipmentStore from './Shipment';
import UserStore from './User';
import { api, readonlyApi, dashboardAPI, paymentAPI, trafficAPI, routingAPI } from './api';
import AssignmentStore from './Assignment';
import DriverScheduleStore from './DriverSchedule';
import DriverStore from './Driver';
import DriverRegistrationStore from './DriverRegistration';
import DriverListStore from './DriverList';
import DriverCrewListStore from './DriverCrewList';
import DriverCrewStore from './DriverCrew';

import DriverPoolListStore from './DriverPoolList';
import DriverPoolStore from './DriverPool';
import SolutionListStore from './SolutionList';
import AssignmentListStore from './AssignmentList';
import ClientStore from './Client';
import GeocodeAddressListStore from './GeocodeAddressList';
import DriverAnnouncementStore from './DriverAnnouncement';
import DriverAnnouncementImportStore from './DriverAnnouncementImport';
import DriverSuspensionStore from './DriverSuspension';
import HistoryStore from './History';
import LookAndFeelStore from './LookAndFeel.js';
import StatsStore from './Stats';
import FilterStore from './Filter';
import DriverPickupTimeStore from './DriverPickupTime';
import MessengerStore from './Messenger';
import MessengerInStore from './MessengerInStore';
import LocationStore from './Location';
import DspStore from './DspStore';
import CallCenterStore from './CallCenter';
import TicketStore from './Ticket';
import BookingStore from './Booking';
import EventStore from './Event';
import AbandonedListStore from './Abandoned';
import SupportDoashboard from './SupportDoashboard';
import PaymentStore from './Payment';
import LyftStore from './Lyft';
import ToastStore from './Toast';
import AppealStore from './Appeal';
import EtaStore from './Eta';
import WorkwhileStore from './Workwhile';
import RegionStore from './Region';
import CustomerProfileStore from './CustomerProfile';
import AddressStore from './Address';
import TrafficStore from './Traffic';
import WarehouseStore from './warehouseStore';
import DriverRatingConfig from './DriverRatingConfig';
import DriverProbationStore from './DriverProbation';
import RequestErrorHandler from './RequestHandler';
import Permission from './Permission';
import SensitiveInfoStore from './SensitiveInfo';
import LinehaulStore from './Linehaul';

const userStore = new UserStore(api);
const clientStore = new ClientStore(api);
const driverStore = new DriverStore(api);
const assignmentStore = new AssignmentStore(api, driverStore, clientStore);
const profileStore = new CustomerProfileStore(api);
const shipmentStore = new ShipmentStore(api, assignmentStore);
const messengerStore = new MessengerStore(api, assignmentStore, userStore);
const locationStore = new LocationStore(api);
const regionStore = new RegionStore();
export const RequestErrorHandlerStore = new RequestErrorHandler();

export const stores = {
  userStore,
  shipmentStore,
  assignmentStore,
  driverStore,
  locationStore,
  clientStore,
  profileStore,
  scheduleStore: new DriverScheduleStore(api),
  driverListStore: new DriverListStore(api),
  driverCrewStore: new DriverCrewStore(api),
  driverCrewListStore: new DriverCrewListStore(api),
  driverPoolStore: new DriverPoolStore(api),
  driverPoolListStore: new DriverPoolListStore(api),
  driverRegistrationStore: new DriverRegistrationStore(api),
  solutionListStore: new SolutionListStore(api),
  assignmentListStore: new AssignmentListStore(api),
  geocodeAddressListStore: new GeocodeAddressListStore(api),
  driverAnnouncementStore: new DriverAnnouncementStore(api),
  driverAnnouncementImportStore: new DriverAnnouncementImportStore(api, regionStore),
  driverSuspensionStore: new DriverSuspensionStore(api),
  historyStore: new HistoryStore(api),
  statsStore: new StatsStore(readonlyApi),
  dashboardFilterStore: new FilterStore(regionStore, userStore),
  dispatchFilterStore: new FilterStore(regionStore, userStore),
  lnfStore: new LookAndFeelStore(),
  driverPickupStore: new DriverPickupTimeStore(api),
  messengerStore: messengerStore,
  messengerInStore: new MessengerInStore(api),
  ticketStore: new TicketStore(api, locationStore),
  bookingStore: new BookingStore(api),
  dspStore: new DspStore(api),
  eventStore: new EventStore(api),
  callCenterStore: new CallCenterStore(api),
  abandonedListStore: new AbandonedListStore(api),
  supportDoashboard: new SupportDoashboard(dashboardAPI),
  paymentStore: new PaymentStore(paymentAPI),
  lyftStore: new LyftStore(api),
  toastStore: new ToastStore(api),
  appealStore: new AppealStore(api),
  etaStore: new EtaStore(api),
  wwStore: new WorkwhileStore(api),
  regionStore,
  addressStore: new AddressStore(api),
  trafficStore: new TrafficStore(trafficAPI),
  warehouseStore: new WarehouseStore(routingAPI),
  driverRatingConfig: new DriverRatingConfig(api),
  driverProbationStore: new DriverProbationStore(api),
  permissionStore: new Permission(),
  requestErrorHandler: RequestErrorHandlerStore,
  sensitiveInfoStore: new SensitiveInfoStore(api),
  linehaulStore: new LinehaulStore(),
};
